import { QueryClient } from "@tanstack/react-query";

/**
 * Fail-closed cache policy: no automatic retries (the backend owns
 * retryability semantics in its diagnostics), no focus/reconnect refetching
 * (refresh is an explicit user action), and no reuse of protected reads —
 * `gcTime: 0` evicts a query the moment its last observer unmounts, so
 * returning to a scope always re-fetches and re-authorizes against the
 * backend instead of rendering a previously cached protected snapshot.
 * Boot responses are `no-store`; the in-memory cache honors the same
 * doctrine across navigations.
 */
export function createWebStudioQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: 0,
        gcTime: 0,
      },
    },
  });
}
